import UploadTextArea from './UploadTextArea';

export default UploadTextArea;
